(() => {
  const init = () => {
    const popup = document.getElementById('halo-edit-cart-popup');
    if (!popup) return;
    const close = popup.querySelector('[data-close-edit-cart]');
    const inerted = new Set();
    let open = false;
    let opener = null;
    const visible = element => element?.isConnected && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert]');
    const controls = () => [...popup.querySelectorAll('button,input,select,textarea,a[href],[tabindex]')].filter(element => !element.disabled && element.tabIndex >= 0 && visible(element));
    const first = () => (controls()[0] || popup).focus({preventScroll: true});
    const release = () => {
      inerted.forEach(element => { element.inert = false; });
      inerted.clear();
    };
    const isolate = () => {
      let current = popup;
      while (current.parentElement) {
        for (const sibling of current.parentElement.children) {
          if (sibling !== current && !sibling.inert && !sibling.matches('script,style,link,.background-overlay')) {
            sibling.inert = true;
            inerted.add(sibling);
          }
        }
        current = current.parentElement;
        if (current === document.body) break;
      }
    };
    document.addEventListener('click', event => {
      const trigger = event.target.closest?.('[data-open-edit-cart]');
      if (trigger) opener = trigger;
    }, true);
    const sync = () => {
      const next = document.body.classList.contains('edit-cart-show');
      if (next === open) return;
      open = next;
      if (open) {
        popup.inert = false;
        isolate();
        let frames = 0;
        const focus = () => {
          if (!open) return;
          if (visible(close)) close.focus({preventScroll: true});
          else if (++frames < 90) requestAnimationFrame(focus);
        };
        requestAnimationFrame(focus);
      } else {
        release();
        if (visible(opener)) opener.focus({preventScroll: true});
        else if (document.body.classList.contains('cart-sidebar-show')) document.querySelector('[data-close-cart-sidebar]')?.focus();
        else document.getElementById('MainContent')?.focus({preventScroll: true});
        popup.inert = true;
      }
    };
    new MutationObserver(sync).observe(document.body, {attributes: true, attributeFilter: ['class']});
    document.addEventListener('focusin', event => {
      if (open && !popup.contains(event.target)) first();
    });
    document.addEventListener('keydown', event => {
      if (!open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        close.click();
      } else if (event.key === 'Tab') {
        const items = controls();
        const start = items[0] || popup;
        const end = items[items.length - 1] || popup;
        if (!popup.contains(document.activeElement) || event.shiftKey && document.activeElement === start || !event.shiftKey && document.activeElement === end || !items.length) {
          event.preventDefault();
          (event.shiftKey ? end : start).focus();
        }
      }
    }, true);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
